<script lang="javascript">
    import ConfirmDialog from "./ConfirmDialog.svelte";

    import ConfirmDialogData from "./ConfirmDialogData";
    export let data = new ConfirmDialogData();

    let visible = data.visible;
</script>

<ConfirmDialog
		bind:open={$visible}
		on:confirm={()=>{ 
            if (data.onConfirm) { 
                data.onConfirm(); 
            }
        }}
		on:cancel={()=>{ 
            $visible = false; 
        }}
	/>